import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

const TicketDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  // Redirect to AgentWorkspace since it handles both new and existing tickets
  React.useEffect(() => {
    navigate(`/workspace/${id}`, { replace: true });
  }, [id, navigate]);

  return (
    <div style={{ padding: 24 }}>
      <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/tickets')}>
        Back to Tickets
                    </Button>
      <p>Redirecting to workspace...</p>
    </div>
  );
};

export default TicketDetail;
